import {
  BrowserDeploymentPostIn,
  BrowserDeploymentUpdateIn,
  BrowserExtensionManagementService,
} from '@/client'
import { useFetch } from '@/composables/useFetch'

export async function _getLastUsages(
  args: Parameters<
    typeof BrowserExtensionManagementService.getBrowserLastUsagesApiV1BrowserLastUsagesGet
  >[0]
) {
  const { data, error, fetchData, loading } = useFetch(
    () =>
      BrowserExtensionManagementService.getBrowserLastUsagesApiV1BrowserLastUsagesGet(
        args
      ),
    null,
    { sendToast: false }
  )

  await fetchData()

  return { data: data.value, error: error.value, loading: loading.value }
}

export async function _getDeployments(
  args: Parameters<
    typeof BrowserExtensionManagementService.getBrowserDeploymentsApiV1BrowserDeploymentsGet
  >[0]
) {
  const { data, error, fetchData, loading } = useFetch(
    () =>
      BrowserExtensionManagementService.getBrowserDeploymentsApiV1BrowserDeploymentsGet(
        args
      ),
    null,
    { sendToast: false }
  )

  await fetchData()

  return { data: data.value, error: error.value, loading: loading.value }
}

export async function _deleteDeployment(id: string) {
  const { data, error, fetchData, loading } = useFetch(
    () =>
      BrowserExtensionManagementService.deleteBrowserDeploymentApiV1BrowserDeploymentsBrowserDeploymentIdDelete(
        {
          browserDeploymentId: id,
        }
      ),
    null,
    { sendToast: true }
  )
  return fetchData().then(() => {
    return { data: data.value, error: error.value, loading: loading.value }
  })
}

export async function _createDeployment(deployment: BrowserDeploymentPostIn) {
  const { data, error, fetchData, loading } = useFetch(
    () =>
      BrowserExtensionManagementService.createBrowserDeploymentApiV1BrowserDeploymentsPost(
        {
          requestBody: deployment,
        }
      ),
    null,
    { sendToast: true }
  )
  return fetchData().then(() => {
    return { data: data.value, error: error.value, loading: loading.value }
  })
}

export async function _patchDeployment(
  id: string,
  deplyoment: BrowserDeploymentUpdateIn
) {
  const { data, error, fetchData, loading } = useFetch(
    () =>
      BrowserExtensionManagementService.patchBrowserDeploymentApiV1BrowserDeploymentsBrowserDeploymentIdPatch(
        {
          browserDeploymentId: id,
          requestBody: deplyoment,
        }
      ),
    null,
    { sendToast: true }
  )
  return fetchData().then(() => {
    return { data: data.value, error: error.value, loading: loading.value }
  })
}
